import type { TemplateParameter } from '../devices/contracts';
import { holdsSecret, reviewScript, SECRET_FINDING } from './script-review';

/**
 * Why a Script library template (WRMM-230) can't be saved, beyond its schema, or null. Pure, shared with the console.
 * No secret in the bytes or a default (nor a default for a secret-named parameter): a template is offered to the whole team and copied into every job. Each declared parameter
 * used: the agent binds them by name to the script's param() block.
 */
export function templateProblem(script: string, parameters: TemplateParameter[]): string | null {
  if (reviewScript(script).some(f => f.title === SECRET_FINDING)
    || parameters.some(p => p.type === 'string' && p.default && (holdsSecret(p.default) || /password|passwd|pwd|secret|token|apikey|api_key|accesskey/i.test(p.name)))) {
    return 'This script contains what looks like a key, token or password. Templates are shared with your whole team and copied into every job; remove it.';
  }
  // Only well-formed names (the schema refuses the rest); the console calls this while a name is still being typed.
  const unused = parameters.find(p => /^[A-Za-z][A-Za-z0-9]{0,63}$/.test(p.name) && !new RegExp(`\\$${p.name}\\b`, 'i').test(script));
  return unused ? `Declare $${unused.name} in the script’s param() block` : null;
}
